// extracted by mini-css-extract-plugin
export default {"navBox":"OSFg1XBrTczBOfps7LkW","sectionBox":"tItpc9Hye8UGjTFfdN8V","expanded":"QTXalgbbs85o1hUGYxNc"};